import { useEffect, type ReactNode } from 'react'

import { analytics } from 'core/analytics/analytics'
import ShipperGuideLayout from 'core/ui/components/shipperguide-layout/ShipperGuideLayout'
import { useDisableSalesforceChat } from 'core/ui/hooks/useDisableSalesforceChat'

import { useSaveUrlToken, type UrlTokenKind } from 'auth/ui/hooks/useSaveUrlToken'

interface PortalPageProps {
  readonly urlTokenKind?: UrlTokenKind
  readonly children: ReactNode
}

/**
 * Shared shell for portal pages: disables the Salesforce chat, initializes
 * analytics, ingests the `?token=` URL param under the declared identity and
 * wraps the content in the portal layout.
 *
 * `urlTokenKind` declares which storage key owns the route's `?token=` URL
 * param when present — it does NOT describe which identity the route's data
 * fetching uses (each use-case picks its own http client), and it is inert
 * for visits without a `?token=` param (e.g. logged-in navigation).
 * Exactly one PortalPage must ingest it per route — never nest PortalPages.
 */
export function PortalPage({ urlTokenKind, children }: PortalPageProps) {
  useDisableSalesforceChat()
  useSaveUrlToken(urlTokenKind)

  useEffect(() => {
    analytics.init()
  }, [])

  return <ShipperGuideLayout>{children}</ShipperGuideLayout>
}
